goog.provide("shadow.js.shim.module$$mui$material$TableHead$default");
shadow.js.shim.module$$mui$material$TableHead$default = shadow.js.require(539, {})["default"];
